import { IEditStatusEmailValues } from "../interfaces/order";

export const parseFormData = (body: IEditStatusEmailValues): FormData => {
  const formData = new FormData();
  Object.keys(body).forEach((key) => {
    if (key.startsWith("footer") && key !== "footer") return;
    const value = body[key];
    if (value) {
      if (typeof value === "boolean") {
        formData.append(key, String(value));
      } else {
        formData.append(key, value);
      }
    }
  });

  return formData;
};
